// Export the useWorkspace hook and context separately to fix React Fast Refresh warnings
import { useContext, createContext } from 'react';
import type { WorkspaceContextType } from '@/contexts/WorkspaceContextType';

// Create the context here to avoid fast refresh issues
export const WorkspaceContext = createContext<WorkspaceContextType | undefined>(undefined);

// Custom hook to use the workspace context
export const useWorkspace = () => {
  const context = useContext(WorkspaceContext);
  if (!context) {
    throw new Error('useWorkspace must be used within a WorkspaceProvider');
  }
  return context;
};